export const AlertIcon = () => {
  return null;
};

export const AirplaneIcon = () => {
  return null;
};

export const BellIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2652 15.309C18.948 14.3214 18.7859 13.2884 18.785 12.2487V9.67963C18.8081 8.05176 18.2416 6.47296 17.1951 5.24868C16.1522 4.02247 14.7047 3.23405 13.1301 3.0345C12.2599 2.94192 11.3747 3.0345 10.5346 3.32638C9.69447 3.60283 8.92962 4.06444 8.28513 4.68035C7.63743 5.28037 7.12118 6.01444 6.77046 6.8341C6.41799 7.65345 6.23403 8.53851 6.23004 9.43403V12.2628C6.2282 13.2983 6.06611 14.3269 5.74981 15.3102L5 17.5849L5.6006 18.4309H9.9954C9.9954 19.1073 10.265 19.7682 10.7302 20.2465C11.1941 20.7223 11.8398 21 12.5006 21C13.1602 21 13.8046 20.7235 14.2698 20.2465C14.735 19.7695 15.0059 19.1073 15.0059 18.4309H19.4007L20 17.5849L19.2652 15.309ZM13.3846 19.3554C13.2692 19.4761 13.1318 19.5722 12.98 19.6382C12.8283 19.7042 12.6654 19.7387 12.5006 19.7399C12.3355 19.7387 12.1723 19.704 12.0204 19.6378C11.8684 19.5716 11.7308 19.4752 11.6154 19.3541C11.4975 19.236 11.4036 19.095 11.339 18.9394C11.2745 18.7839 11.2405 18.6167 11.2392 18.4476H13.7457C13.7509 18.6163 13.7216 18.7843 13.6596 18.9407C13.5976 19.097 13.5044 19.2383 13.3859 19.3554H13.3846ZM6.46953 17.1567L6.93472 15.7243C7.29747 14.6084 7.48497 13.4404 7.49018 12.2641V9.43403C7.49018 8.71012 7.64064 8.00291 7.92527 7.35615C8.2099 6.69523 8.6149 6.11019 9.14027 5.63315C9.66564 5.14196 10.2813 4.77164 10.9408 4.55691C11.6154 4.32546 12.3201 4.24831 13.0097 4.32546C14.2736 4.49589 15.4324 5.13652 16.266 6.12561C17.0998 7.11594 17.548 8.38689 17.5249 9.69506V12.2796C17.5249 13.4484 17.7054 14.6172 18.0803 15.7397L18.5455 17.1708H6.47079V17.1554L6.46953 17.1567Z"
        fill="#10A823"
      />
    </svg>
  );
};

export const BriefcaseIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5392 6.60904H13.6569V5.9109C13.6564 5.5037 13.4972 5.1133 13.2142 4.82537C12.9311 4.53743 12.5473 4.37546 12.1471 4.375H8.85294C8.45266 4.37546 8.06889 4.53743 7.78585 4.82537C7.50281 5.1133 7.34359 5.5037 7.34314 5.9109V6.60904H4.46078C4.20606 6.60934 3.96185 6.71241 3.78173 6.89564C3.60161 7.07887 3.50029 7.32731 3.5 7.58644V16.5226C3.50029 16.7817 3.60161 17.0302 3.78173 17.2134C3.96185 17.3966 4.20606 17.4997 4.46078 17.5H16.5392C16.7939 17.4997 17.0382 17.3966 17.2183 17.2134C17.3984 17.0302 17.4997 16.7817 17.5 16.5226V7.58644C17.4997 7.32731 17.3984 7.07887 17.2183 6.89564C17.0382 6.71241 16.7939 6.60934 16.5392 6.60904ZM4.32353 10.2394H16.6765V13.8697H4.32353V10.2394ZM8.16667 5.9109C8.16687 5.72581 8.23923 5.54835 8.36789 5.41747C8.49655 5.28659 8.67099 5.21297 8.85294 5.21277H12.1471C12.329 5.21297 12.5035 5.28659 12.6321 5.41747C12.7608 5.54835 12.8331 5.72581 12.8333 5.9109V6.60904H8.16667V5.9109ZM4.46078 7.44681H16.5392C16.5756 7.44686 16.6105 7.46159 16.6362 7.48777C16.6619 7.51394 16.6764 7.54942 16.6765 7.58644V9.4016H4.32353V7.58644C4.32358 7.54942 4.33806 7.51394 4.36379 7.48777C4.38952 7.46159 4.4244 7.44686 4.46078 7.44681ZM16.5392 16.6622H4.46078C4.4244 16.6622 4.38952 16.6475 4.36379 16.6213C4.33806 16.5951 4.32358 16.5596 4.32353 16.5226V14.7074H16.6765V16.5226C16.6764 16.5596 16.6619 16.5951 16.6362 16.6213C16.6105 16.6475 16.5756 16.6622 16.5392 16.6622Z"
        fill="#B5B5B5"
      />
    </svg>
  );
};

export const BuildingIcon = () => {
  return null;
};

export const CashIcon = () => {
  return null;
};

export const CreditCardIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0625 5.46875C17.3526 5.46875 17.6308 5.58398 17.8359 5.7891C18.041 5.99422 18.1562 6.27242 18.1562 6.5625V15.3125C18.1562 15.6026 18.041 15.8808 17.8359 16.0859C17.6308 16.291 17.3526 16.4062 17.0625 16.4062H3.9375C3.64742 16.4062 3.36922 16.291 3.1641 16.0859C2.95898 15.8808 2.84375 15.6026 2.84375 15.3125V6.5625C2.84375 6.27242 2.95898 5.99422 3.1641 5.7891C3.36922 5.58398 3.64742 5.46875 3.9375 5.46875H17.0625ZM3.9375 4.375C3.35734 4.375 2.80094 4.60547 2.3907 5.0157C1.98047 5.42594 1.75 5.98234 1.75 6.5625L1.75 15.3125C1.75 15.8927 1.98047 16.4491 2.3907 16.8593C2.80094 17.2695 3.35734 17.5 3.9375 17.5H17.0625C17.6427 17.5 18.1991 17.2695 18.6093 16.8593C19.0195 16.4491 19.25 15.8927 19.25 15.3125V6.5625C19.25 5.98234 19.0195 5.42594 18.6093 5.0157C18.1991 4.60547 17.6427 4.375 17.0625 4.375H3.9375Z"
        fill="#B5B5B5"
      />
      <path
        d="M3.9375 8.20312C3.9375 8.05808 3.99512 7.91899 4.09768 7.81643C4.20024 7.71387 4.33933 7.65625 4.48438 7.65625H6.67188C6.81692 7.65625 6.95601 7.71387 7.05857 7.81643C7.16113 7.91899 7.21875 8.05808 7.21875 8.20312V9.29688C7.21875 9.44192 7.16113 9.58101 7.05857 9.68357C6.95601 9.78613 6.81692 9.84375 6.67188 9.84375H4.48438C4.33933 9.84375 4.20024 9.78613 4.09768 9.68357C3.99512 9.58101 3.9375 9.44192 3.9375 9.29688V8.20312ZM3.9375 11.4844C3.9375 11.3393 3.99512 11.2002 4.09768 11.0977C4.20024 10.9951 4.33933 10.9375 4.48438 10.9375H9.95312C10.0982 10.9375 10.2373 10.9951 10.3398 11.0977C10.4424 11.2002 10.5 11.3393 10.5 11.4844C10.5 11.6294 10.4424 11.7685 10.3398 11.8711C10.2373 11.9736 10.0982 12.0312 9.95312 12.0312H4.48438C4.33933 12.0312 4.20024 11.9736 4.09768 11.8711C3.99512 11.7685 3.9375 11.6294 3.9375 11.4844ZM3.9375 13.6719C3.9375 13.5268 3.99512 13.3877 4.09768 13.2852C4.20024 13.1826 4.33933 13.125 4.48438 13.125H5.57812C5.72317 13.125 5.86226 13.1826 5.96482 13.2852C6.06738 13.3877 6.125 13.5268 6.125 13.6719C6.125 13.8169 6.06738 13.956 5.96482 14.0586C5.86226 14.1611 5.72317 14.2188 5.57812 14.2188H4.48438C4.33933 14.2188 4.20024 14.1611 4.09768 14.0586C3.99512 13.956 3.9375 13.8169 3.9375 13.6719ZM7.21875 13.6719C7.21875 13.5268 7.27637 13.3877 7.37893 13.2852C7.48149 13.1826 7.62058 13.125 7.76562 13.125H8.85938C9.00442 13.125 9.14352 13.1826 9.24607 13.2852C9.34863 13.3877 9.40625 13.5268 9.40625 13.6719C9.40625 13.8169 9.34863 13.956 9.24607 14.0586C9.14352 14.1611 9.00442 14.2188 8.85938 14.2188H7.76562C7.62058 14.2188 7.48149 14.1611 7.37893 14.0586C7.27637 13.956 7.21875 13.8169 7.21875 13.6719ZM10.5 13.6719C10.5 13.5268 10.5576 13.3877 10.6602 13.2852C10.7627 13.1826 10.9018 13.125 11.0469 13.125H12.1406C12.2857 13.125 12.4248 13.1826 12.5273 13.2852C12.6299 13.3877 12.6875 13.5268 12.6875 13.6719C12.6875 13.8169 12.6299 13.956 12.5273 14.0586C12.4248 14.1611 12.2857 14.2188 12.1406 14.2188H11.0469C10.9018 14.2188 10.7627 14.1611 10.6602 14.0586C10.5576 13.956 10.5 13.8169 10.5 13.6719ZM13.7812 13.6719C13.7812 13.5268 13.8389 13.3877 13.9414 13.2852C14.044 13.1826 14.1831 13.125 14.3281 13.125H15.4219C15.5669 13.125 15.706 13.1826 15.8086 13.2852C15.9111 13.3877 15.9688 13.5268 15.9688 13.6719C15.9688 13.8169 15.9111 13.956 15.8086 14.0586C15.706 14.1611 15.5669 14.2188 15.4219 14.2188H14.3281C14.1831 14.2188 14.044 14.1611 13.9414 14.0586C13.8389 13.956 13.7812 13.8169 13.7812 13.6719Z"
        fill="#B5B5B5"
      />
    </svg>
  );
};

export const CrossIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18"
        stroke="#10AB7C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 6L18 18"
        stroke="#10AB7C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DropdownArrowDown = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.22926 9.23626C6.37625 9.08498 6.5755 9 6.78324 9C6.99098 9 7.19023 9.08498 7.33722 9.23626L12.0094 14.0511L16.6816 9.23626C16.8303 9.09356 17.0268 9.01587 17.2299 9.01957C17.433 9.02326 17.6268 9.10804 17.7704 9.25606C17.914 9.40407 17.9963 9.60376 17.9999 9.81305C18.0035 10.0223 17.9281 10.2249 17.7896 10.378L12.5634 15.7637C12.4164 15.915 12.2172 16 12.0094 16C11.8017 16 11.6024 15.915 11.4555 15.7637L6.22926 10.378C6.08246 10.2266 6 10.0212 6 9.80715C6 9.59306 6.08246 9.38773 6.22926 9.23626Z"
        fill="#C4C4C4"
      />
    </svg>
  );
};

export const DropdownArrowUp = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7707 14.7637C17.6238 14.915 17.4245 15 17.2168 15C17.009 15 16.8098 14.915 16.6628 14.7637L11.9906 9.94892L7.31835 14.7637C7.16974 14.9064 6.97319 14.9841 6.7701 14.9804C6.56701 14.9767 6.37324 14.892 6.22961 14.7439C6.08598 14.5959 6.00371 14.3962 6.00012 14.187C5.99654 13.9777 6.07193 13.7751 6.2104 13.622L11.4366 8.23626C11.5836 8.08498 11.7828 8 11.9906 8C12.1983 8 12.3976 8.08498 12.5445 8.23626L17.7707 13.622C17.9175 13.7734 18 13.9788 18 14.1929C18 14.4069 17.9175 14.6123 17.7707 14.7637Z"
        fill="#C4C4C4"
      />
    </svg>
  );
};

export const EyesIcon = () => {
  return null;
};

export const FiltersIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99992 10C5.92039 10 6.66658 9.25383 6.66658 8.33335C6.66658 7.41288 5.92039 6.66669 4.99992 6.66669C4.07944 6.66669 3.33325 7.41288 3.33325 8.33335C3.33325 9.25383 4.07944 10 4.99992 10Z"
        stroke="#10A823"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3.33331V6.66665"
        stroke="#10A823"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10V16.6667"
        stroke="#10A823"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99992 15C10.9204 15 11.6666 14.2538 11.6666 13.3334C11.6666 12.4129 10.9204 11.6667 9.99992 11.6667C9.07944 11.6667 8.33325 12.4129 8.33325 13.3334C8.33325 14.2538 9.07944 15 9.99992 15Z"
        stroke="#10A823"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.33331V11.6666"
        stroke="#10A823"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15V16.6667"
        stroke="#10A823"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9999 7.50002C15.9204 7.50002 16.6666 6.75383 16.6666 5.83335C16.6666 4.91288 15.9204 4.16669 14.9999 4.16669C14.0794 4.16669 13.3333 4.91288 13.3333 5.83335C13.3333 6.75383 14.0794 7.50002 14.9999 7.50002Z"
        stroke="#10A823"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 3.33331V4.16665"
        stroke="#10A823"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7.5V16.6667"
        stroke="#10A823"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FireIcon = () => {
  return null;
};

export const GlobeIcon = () => {
  return null;
};

export const InstrumentsIcon = () => {
  return null;
};

export const LocationIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9375 2.625C14.562 2.625 17.5 5.52695 17.5 9.10702C17.5 11.8461 15.5514 14.8311 11.7048 18.0941C11.4909 18.2756 11.2182 18.3752 10.9362 18.375C10.6543 18.3748 10.3817 18.2746 10.1682 18.0928L9.91375 17.8747C6.2374 14.6968 4.375 11.7849 4.375 9.10702C4.375 5.52695 7.31298 2.625 10.9375 2.625ZM10.9375 3.62223C9.46478 3.62223 8.05239 4.20009 7.01102 5.22869C5.96965 6.25728 5.38462 7.65236 5.38462 9.10702C5.38462 11.4352 7.09962 14.1178 10.5767 17.1228L10.8278 17.3375C10.8583 17.3634 10.8972 17.3777 10.9375 17.3777C10.9778 17.3777 11.0167 17.3634 11.0472 17.3375C14.6926 14.2448 16.4904 11.4904 16.4904 9.10702C16.4904 8.38674 16.3468 7.67352 16.0677 7.00808C15.7886 6.34264 15.3796 5.738 14.864 5.22869C14.3483 4.71938 13.7362 4.31537 13.0625 4.03974C12.3888 3.7641 11.6667 3.62223 10.9375 3.62223ZM10.9375 6.61393C11.6069 6.61393 12.2489 6.8766 12.7223 7.34414C13.1956 7.81168 13.4615 8.44581 13.4615 9.10702C13.4615 9.76822 13.1956 10.4023 12.7223 10.8699C12.2489 11.3374 11.6069 11.6001 10.9375 11.6001C10.2681 11.6001 9.62608 11.3374 9.15274 10.8699C8.67939 10.4023 8.41346 9.76822 8.41346 9.10702C8.41346 8.44581 8.67939 7.81168 9.15274 7.34414C9.62608 6.8766 10.2681 6.61393 10.9375 6.61393ZM10.9375 7.61117C10.5359 7.61117 10.1507 7.76876 9.86664 8.04929C9.58263 8.32982 9.42308 8.71029 9.42308 9.10702C9.42308 9.50374 9.58263 9.88421 9.86664 10.1647C10.1507 10.4453 10.5359 10.6029 10.9375 10.6029C11.3391 10.6029 11.7243 10.4453 12.0084 10.1647C12.2924 9.88421 12.4519 9.50374 12.4519 9.10702C12.4519 8.71029 12.2924 8.32982 12.0084 8.04929C11.7243 7.76876 11.3391 7.61117 10.9375 7.61117Z"
        fill="#B5B5B5"
      />
    </svg>
  );
};

export const MagnifierSVGIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7143 18.4286C14.9748 18.4286 18.4286 14.9748 18.4286 10.7143C18.4286 6.4538 14.9748 3 10.7143 3C6.4538 3 3 6.4538 3 10.7143C3 14.9748 6.4538 18.4286 10.7143 18.4286Z"
        stroke="#C4C4C4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 16.5L21 21"
        stroke="#C4C4C4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MagnifierIcon = () => {
  return null;
};

export const MoneyBag = () => {
  return null;
};

export const NerdFaceIcon = () => {
  return null;
};

export const PalmTreeIcon = () => {
  return null;
};

export const PlusIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4.99994V18.9999"
        stroke="#C4C4C4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 12H19"
        stroke="#C4C4C4"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1172 16.5625C16.951 14.5535 15.0844 13.0457 12.8751 12.3281C13.934 11.6984 14.757 10.7384 15.2174 9.59565C15.6779 8.45288 15.7504 7.19053 15.4239 6.00253C15.0974 4.81454 14.3898 3.76661 13.4099 3.01973C12.4301 2.27286 11.2321 1.86835 10.0001 1.86835C8.768 1.86835 7.57002 2.27286 6.59016 3.01973C5.61029 3.76661 4.90274 4.81454 4.57621 6.00253C4.24967 7.19053 4.32221 8.45288 4.78268 9.59565C5.24315 10.7384 6.06608 11.6984 7.12505 12.3281C4.91576 13.0457 3.04907 14.5535 1.88287 16.5625C1.83395 16.6335 1.80024 16.7138 1.78386 16.7984C1.76747 16.883 1.76877 16.9701 1.78766 17.0542C1.80655 17.1383 1.84262 17.2175 1.89362 17.287C1.94462 17.3565 2.00944 17.4147 2.084 17.4579C2.15857 17.5011 2.24127 17.5285 2.3269 17.5382C2.41254 17.5479 2.49926 17.5398 2.58162 17.5145C2.66399 17.4891 2.7402 17.4469 2.80549 17.3906C2.87078 17.3344 2.92372 17.2652 2.96099 17.1875C3.67535 15.9531 4.70176 14.9283 5.93725 14.2158C7.17273 13.5033 8.57386 13.1283 10.0001 13.1283C11.4263 13.1283 12.8274 13.5033 14.0629 14.2158C15.2983 14.9283 16.3248 15.9531 17.0391 17.1875C17.0764 17.2652 17.1293 17.3344 17.1946 17.3906C17.2599 17.4469 17.3361 17.4891 17.4185 17.5145C17.5008 17.5398 17.5876 17.5479 17.6732 17.5382C17.7588 17.5285 17.8415 17.5011 17.9161 17.4579C17.9907 17.4147 18.0555 17.3565 18.1065 17.287C18.1575 17.2175 18.1936 17.1383 18.2124 17.0542C18.2313 16.9701 18.2326 16.883 18.2162 16.7984C18.1999 16.7138 18.1662 16.6335 18.1172 16.5625ZM5.62505 7.49999C5.62505 6.6347 5.88164 5.78884 6.36237 5.06937C6.8431 4.34991 7.52639 3.78915 8.32581 3.45802C9.12524 3.12689 10.0049 3.04025 10.8536 3.20906C11.7022 3.37787 12.4818 3.79455 13.0936 4.4064C13.7055 5.01825 14.1222 5.7978 14.291 6.64647C14.4598 7.49514 14.3732 8.3748 14.042 9.17423C13.7109 9.97366 13.1501 10.6569 12.4307 11.1377C11.7112 11.6184 10.8653 11.875 10.0001 11.875C8.83973 11.875 7.72693 11.4141 6.90646 10.5936C6.08599 9.77311 5.62505 8.66031 5.62505 7.49999Z"
        fill="#10AB7C"
      />
    </svg>
  );
};

export const TimeIcon = () => (
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18.25C14.8325 18.25 18.75 14.3325 18.75 9.5C18.75 4.66751 14.8325 0.75 10 0.75C5.16751 0.75 1.25 4.66751 1.25 9.5C1.25 14.3325 5.16751 18.25 10 18.25Z"
      stroke="#10AB7C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 4.5V9.5L12.5 12"
      stroke="#10AB7C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FireEmoji = () => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57 26.2C57 26.2 54 29 48.9 32.3C47.5 24.2 43.6 14.2 36 2C36 2 33.5 15.1 25.2 27.4C21.6 21.8 20 17.4 20 17.4C-6.00004 43.5 15.6 62 29.2 62C46.6 62 61.9 53.6 57 26.2Z"
        fill="#FF9D33"
      />
      <path
        d="M46.7 49.3998C48.2 46.0998 49.2999 41.7998 49.5 36.3998C49.5 36.3998 47.3999 38.1998 43.7999 40.4998C42.7999 35.0998 40.0999 28.4998 34.7999 20.2998C34.7999 20.2998 33.1 28.9998 27.3 37.2998C24.8 33.5998 23.7 30.5998 23.7 30.5998C19.4 37.3998 17.7 42.7998 17.6 47.0998C15.2 46.1998 13.7 45.4998 13.7 45.4998C17.8 57.6998 26.3 60.3998 30.1 60.3998C36.9 60.3998 43.7999 58.3998 50.5999 48.6998C50.5999 48.5998 49.1 48.9998 46.7 49.3998Z"
        fill="#FFCE31"
      />
      <path
        d="M21.9001 43.9C21.9001 43.9 24.7001 47.7 26.8001 46.8C26.8001 46.8 30.8001 40.5 36.6001 37C36.6001 37 35.4001 46.6 36.8001 48.3C38.6001 50.6 43.5001 45.8 43.5001 45.8C43.5001 51.5 37.3001 58.6 31.7001 58.6C26.3001 58.6 18.5001 52.4 21.9001 43.9Z"
        fill="#FFDF85"
      />
      <path
        d="M49.7999 18.1C51.8999 15.1 53.2999 11.9 53.2999 11.9C56.7999 17.7 54.6999 21.2 53.1999 22.3C51.0999 23.9 47.3999 21.6 49.7999 18.1ZM11.5999 17.1C9.49994 13.6 9.29994 9.2 9.29994 9.2C4.29994 16.7 6.19994 20.9 7.89994 22.1C10.0999 23.8 13.8999 21.2 11.5999 17.1ZM23.1999 9.3C23.4999 6.9 22.4999 4.5 22.4999 4.5C27.1999 7.6 27.1999 10.2 26.5999 11.3C25.6999 12.6 22.8999 12 23.1999 9.3Z"
        fill="#FF9D33"
      />
    </svg>
  );
};

export const BreadcrumbsHome = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0988 5.11725L9.43238 1.49109C9.02287 1.17281 8.51884 1 8 1C7.48116 1 6.97713 1.17281 6.56762 1.49109L1.90038 5.11725C1.61989 5.33517 1.39296 5.61425 1.23691 5.93317C1.08087 6.2521 0.999833 6.60243 1 6.95742V13.2516C1 13.7153 1.18437 14.16 1.51256 14.4879C1.84075 14.8158 2.28587 15 2.75 15H13.25C13.7141 15 14.1592 14.8158 14.4874 14.4879C14.8156 14.16 15 13.7153 15 13.2516V6.95742C15 6.23796 14.6675 5.55872 14.0988 5.11725Z"
      stroke="#B5B5B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4736 10.6159C9.53988 11.7812 6.40563 11.7812 4.47363 10.6159"
      stroke="#B5B5B5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRight = (props: any) => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={props.onClick}
    aria-label="arrow"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.236261 11.7707C0.0849756 11.6238 0 11.4245 0 11.2168C0 11.009 0.0849756 10.8098 0.236261 10.6628L5.05108 5.99057L0.236261 1.31835C0.0935609 1.16974 0.0158737 0.973191 0.0195664 0.770101C0.0232591 0.56701 0.108043 0.373238 0.256056 0.229608C0.40407 0.0859785 0.603755 0.00370598 0.813045 0.00012207C1.02234 -0.00346088 1.22489 0.0719261 1.37803 0.2104L6.76374 5.43659C6.91502 5.58358 7 5.78283 7 5.99057C7 6.19831 6.91502 6.39756 6.76374 6.54454L1.37803 11.7707C1.22656 11.9175 1.02123 12 0.807145 12C0.593063 12 0.387734 11.9175 0.236261 11.7707Z"
      fill="#B5B5B5"
    />
  </svg>
);

export const Instagram = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 7.25C11.8628 7.25 10.7511 7.58723 9.80547 8.21905C8.85989 8.85087 8.1229 9.74889 7.68769 10.7996C7.25249 11.8502 7.13862 13.0064 7.36049 14.1218C7.58235 15.2372 8.12998 16.2617 8.93414 17.0659C9.73829 17.87 10.7628 18.4177 11.8782 18.6395C12.9936 18.8614 14.1498 18.7475 15.2004 18.3123C16.2511 17.8771 17.1491 17.1401 17.781 16.1945C18.4128 15.2489 18.75 14.1372 18.75 13C18.75 11.475 18.1442 10.0125 17.0659 8.93414C15.9875 7.8558 14.525 7.25 13 7.25ZM13 17.25C12.1594 17.25 11.3377 17.0007 10.6388 16.5337C9.93992 16.0668 9.39518 15.403 9.07351 14.6264C8.75184 13.8498 8.66768 12.9953 8.83166 12.1709C8.99565 11.3464 9.40042 10.5892 9.9948 9.9948C10.5892 9.40042 11.3464 8.99565 12.1709 8.83166C12.9953 8.66768 13.8498 8.75184 14.6264 9.07351C15.403 9.39518 16.0668 9.93992 16.5337 10.6388C17.0007 11.3377 17.25 12.1594 17.25 13C17.2467 14.1262 16.7979 15.2052 16.0016 16.0016C15.2052 16.7979 14.1262 17.2467 13 17.25ZM18.5 0.75H7.5C5.70979 0.75 3.9929 1.46116 2.72703 2.72703C1.46116 3.9929 0.75 5.70979 0.75 7.5V18.5C0.75 20.2902 1.46116 22.0071 2.72703 23.273C3.9929 24.5388 5.70979 25.25 7.5 25.25H18.5C20.2902 25.25 22.0071 24.5388 23.273 23.273C24.5388 22.0071 25.25 20.2902 25.25 18.5V7.5C25.25 5.70979 24.5388 3.9929 23.273 2.72703C22.0071 1.46116 20.2902 0.75 18.5 0.75ZM23.75 18.5C23.75 19.8924 23.1969 21.2277 22.2123 22.2123C21.2277 23.1969 19.8924 23.75 18.5 23.75H7.5C6.10761 23.75 4.77225 23.1969 3.78769 22.2123C2.80312 21.2277 2.25 19.8924 2.25 18.5V7.5C2.25 6.10761 2.80312 4.77225 3.78769 3.78769C4.77225 2.80312 6.10761 2.25 7.5 2.25H18.5C19.8924 2.25 21.2277 2.80312 22.2123 3.78769C23.1969 4.77225 23.75 6.10761 23.75 7.5V18.5ZM20.75 6.5C20.75 6.74723 20.6767 6.9889 20.5393 7.19446C20.402 7.40002 20.2068 7.56024 19.9784 7.65485C19.7499 7.74946 19.4986 7.77421 19.2561 7.72598C19.0137 7.67775 18.7909 7.5587 18.6161 7.38388C18.4413 7.20907 18.3223 6.98634 18.274 6.74386C18.2258 6.50139 18.2505 6.25005 18.3451 6.02165C18.4398 5.79324 18.6 5.59801 18.8055 5.46066C19.0111 5.32331 19.2528 5.25 19.5 5.25C19.8315 5.25 20.1495 5.3817 20.3839 5.61612C20.6183 5.85054 20.75 6.16848 20.75 6.5Z"
      fill="#10A823"
    />
  </svg>
);

export const Telegram = () => (
  <svg
    width="28"
    height="25"
    viewBox="0 0 28 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.7498 1.16223C26.5082 0.952951 26.2143 0.813313 25.8994 0.758266C25.5845 0.70322 25.2606 0.734836 24.9623 0.849732L1.88734 9.91224C1.53329 10.0494 1.23345 10.298 1.03307 10.6205C0.832691 10.943 0.742641 11.322 0.776508 11.7001C0.810375 12.0783 0.966322 12.4352 1.22082 12.717C1.47531 12.9988 1.81455 13.1902 2.18734 13.2622L8.24984 14.4747V21.9997C8.25025 22.3445 8.3525 22.6815 8.54375 22.9684C8.735 23.2553 9.00674 23.4793 9.32484 23.6122C9.53933 23.6996 9.76825 23.7463 9.99984 23.7497C10.2299 23.7511 10.4578 23.7065 10.6704 23.6185C10.8829 23.5305 11.0757 23.4009 11.2373 23.2372L14.6498 19.8247L19.7498 24.3122C20.0657 24.5955 20.4755 24.7514 20.8998 24.7497C21.0827 24.7513 21.2644 24.7217 21.4373 24.6622C21.726 24.5705 21.9854 24.4043 22.1895 24.1805C22.3935 23.9567 22.5351 23.6831 22.5998 23.3872L27.3123 2.87473C27.3828 2.56511 27.3676 2.24216 27.2685 1.94049C27.1694 1.63882 26.9901 1.36979 26.7498 1.16223ZM2.28734 11.5622C2.2786 11.5095 2.28889 11.4555 2.31637 11.4097C2.34385 11.3639 2.38673 11.3293 2.43734 11.3122L21.7498 3.72473L8.82484 13.0622L2.48734 11.7872C2.4321 11.7811 2.3811 11.7547 2.34417 11.7131C2.30724 11.6716 2.287 11.6178 2.28734 11.5622ZM10.1748 22.1747C10.1402 22.2111 10.0949 22.2355 10.0455 22.2445C9.99606 22.2535 9.94508 22.2466 9.89984 22.2247C9.8559 22.2056 9.81839 22.1742 9.79179 22.1343C9.7652 22.0944 9.75064 22.0477 9.74984 21.9997V15.5122L13.5123 18.8372L10.1748 22.1747ZM21.1498 23.0497C21.1413 23.0931 21.1214 23.1334 21.0922 23.1666C21.063 23.1998 21.0255 23.2246 20.9836 23.2386C20.9417 23.2525 20.8968 23.2552 20.8536 23.2461C20.8103 23.2371 20.7702 23.2168 20.7373 23.1872L10.1998 13.9122L25.8248 2.63723L21.1498 23.0497Z"
      fill="#10A823"
    />
  </svg>
);

export const Twitter = () => (
  <svg
    width="28"
    height="24"
    viewBox="0 0 28 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.6875 3.71256C27.6311 3.57645 27.5357 3.46 27.4135 3.37775C27.2912 3.29549 27.1474 3.25108 27 3.25006H23.05C22.5618 2.35334 21.8436 1.60279 20.9693 1.07554C20.0949 0.548299 19.096 0.263376 18.075 0.250055C16.5411 0.243386 15.0669 0.844663 13.9753 1.92229C12.8836 2.99992 12.2632 4.46614 12.25 6.00006V7.08756C6.95003 5.82506 2.57503 1.51256 2.52503 1.47505C2.42867 1.37992 2.30834 1.31266 2.17683 1.2804C2.04532 1.24813 1.90752 1.25208 1.77807 1.29181C1.64862 1.33154 1.53234 1.40558 1.44157 1.50607C1.3508 1.60656 1.28894 1.72974 1.26253 1.86256C0.175031 7.81256 1.96253 11.7876 3.65003 14.0751C4.54503 15.2999 5.64446 16.3612 6.90003 17.2126C4.96253 19.5626 1.77503 20.7876 1.73753 20.8001C1.63103 20.8393 1.53502 20.9025 1.45697 20.9849C1.37892 21.0673 1.32094 21.1666 1.28753 21.2751C1.25206 21.3809 1.2415 21.4935 1.25668 21.604C1.27186 21.7146 1.31236 21.8202 1.37503 21.9126C1.50003 22.1001 2.72503 23.7501 7.00003 23.7501C15.7125 23.7501 23 17.0126 23.7 8.36256L27.525 4.52506C27.6335 4.42347 27.7074 4.29054 27.7365 4.14486C27.7657 3.99917 27.7485 3.84802 27.6875 3.71256ZM22.4375 7.50006C22.3075 7.62977 22.2316 7.80401 22.225 7.98756C21.7125 15.9876 15.025 22.2501 7.00003 22.2501C5.26253 22.2501 4.15003 21.9501 3.48753 21.6501C4.90003 20.9376 7.21253 19.5376 8.62503 17.4126C8.68131 17.3245 8.71917 17.2259 8.73636 17.1228C8.75354 17.0197 8.74969 16.9141 8.72503 16.8126C8.69839 16.7086 8.6501 16.6115 8.58332 16.5274C8.51655 16.4434 8.43279 16.3745 8.33753 16.3251C8.31253 16.3251 6.43753 15.3501 4.81253 13.1251C2.87503 10.4751 2.11253 7.23756 2.53753 3.50006C4.36253 5.05006 8.30003 7.97506 12.875 8.73756C12.9827 8.75801 13.0936 8.7542 13.1996 8.72642C13.3056 8.69863 13.4041 8.64756 13.4879 8.57692C13.5718 8.50629 13.6388 8.41786 13.6841 8.31807C13.7294 8.21828 13.752 8.10964 13.75 8.00006V6.00006C13.7599 4.86728 14.2177 3.78446 15.0234 2.98814C15.8291 2.19182 16.9172 1.74671 18.05 1.75006C18.8686 1.76187 19.6665 2.00845 20.349 2.46049C21.0315 2.91253 21.5698 3.55101 21.9 4.30006C21.9571 4.4348 22.0529 4.54954 22.1753 4.62967C22.2977 4.7098 22.4412 4.75171 22.5875 4.75006H25.1875L22.4375 7.50006Z"
      fill="#10A823"
    />
  </svg>
);
